import { useCallback } from "react";
import type { Features } from "@KassaroAB/shared/types/enums/Features";
import type { StoreId } from "@KassaroAB/shared/types/ids";
import { useGetActiveFeaturesQuery } from "../query/billingItemsQuery";

export const useHasCatalogFeature = (
  storeId: StoreId | null,
  isChain: boolean,
): ((features?: Features[]) => boolean) => {
  const { data: activeFeatures } = useGetActiveFeaturesQuery(isChain ? null : storeId);
  return useCallback(
    (features?: Features[]) =>
      isChain ||
      !features ||
      features.some((feature) => activeFeatures?.includes(feature) ?? false),
    [activeFeatures, isChain],
  );
};
